export default function SectionLabel({ index, children, testid }) {
  return (
    <div data-testid={testid} className="flex items-center gap-3">
      {index && (
        <span className="font-mono-tech text-[11px] text-zinc-500 tracking-[0.2em]">
          {index}
        </span>
      )}
      <span className="h-px w-8 bg-zinc-300" />
      <span className="label-mono text-zinc-600">{children}</span>
    </div>
  );
}
